// Environment variables - Vite/Vitest will replace import.meta.env at build/test time
// Vitest handles import.meta.env automatically when envPrefix: ['VITE_'] is set
const envVars = import.meta.env || {};

/** Branch / deploy env name → customers API subdomain segment (dev, prod, …) */
const apiEnvByBranch = {
  development: 'dev',
  master: 'prod',
};

const identityApiEnvByBranch = {
  ...apiEnvByBranch,
  'dev-mig': 'dev'
}

const config = {
  apiRoot: envVars.VITE_API_URL
  ? envVars.VITE_API_URL
  :envVars.VITE_ENV
    ? `https://${envVars.VITE_ENV}-api.${envVars.VITE_HOSTED_ZONE_NAME}`
    : 'http://localhost:8090',

  customersApiServiceRoot: envVars.VITE_CUSTOMERS_API_SERVICE_URL
  ? envVars.VITE_CUSTOMERS_API_SERVICE_URL
  : envVars.VITE_ENV
    ? `https://${apiEnvByBranch[envVars.VITE_ENV] ?? envVars.VITE_ENV}-customers-api.${envVars.VITE_HOSTED_ZONE_NAME}/api`
    : 'http://localhost:8095/api',

  tokenKey: 'authorization_token',
  redirectRouteOnAuthenticationFaliure: '/login',
  authServiceRoot: envVars.VITE_AUTH_SERVICE_URL ? envVars.VITE_AUTH_SERVICE_URL :
   envVars.VITE_ENV
    ? `https://${identityApiEnvByBranch[envVars.VITE_ENV] ?? envVars.VITE_ENV}-identity-api.${envVars.VITE_HOSTED_ZONE_NAME}/api/identity`
   : 'http://localhost:8101/api/identity',
  /**
   * Public logo CDN base URL (no trailing slash).
   * prod: logos-prod.rxa.razormetrics.com | otherwise: logos-dev.rxa.razormetrics-dev.com
   */
  logoBucketBaseUrl: `https://${
    ["master", "production", "prod"].includes((envVars.VITE_ENV || "").trim().toLowerCase())
      ? "logos-prod.rxa.razormetrics.com"
      : "logos-dev.rxa.razormetrics-dev.com"
  }`,
};

/** Deployed production uses VITE_ENV=master; also treat production/prod as production. */
const PRODUCTION_ENVIRONMENT_NAMES = new Set(["master", "production", "prod"]);

export const env = {
  environment: envVars.VITE_ENV,
};

/** True when built for production (hidden Test Data nav, etc.). Local dev (no VITE_ENV) is false. */
export function isProductionEnvironment() {
  const name = (envVars.VITE_ENV || "").trim().toLowerCase();
  if (!name) {
    return false;
  }
  return PRODUCTION_ENVIRONMENT_NAMES.has(name);
}

export const version = {
  commitVersion: envVars.VITE_COMMIT_VERSION,
  releaseNumber: '9.7',
};

export default config;
